






































































import {
  defineComponent,
  onMounted,
  ref,
  Ref,
  computed,
} from '@vue/composition-api';
import {
  PermissionItem,
  UpdatePermissionPayload,
  PermissionName,
} from '@oare/types';
import sl from '@/serviceLocator';

export default defineComponent({
  props: {
    groupId: {
      type: String,
      required: true,
    },
  },
  setup({ groupId }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const loading = ref(false);

    const allPermissionsOptions: Ref<PermissionItem[]> = ref([]);

    const allPermissionTypes = computed(() => {
      const types = allPermissionsOptions.value.map(
        permission => permission.type
      );
      return [...new Set(types)];
    });

    const groupPermissions: Ref<PermissionItem[]> = ref([]);

    const groupPermissionNames: Ref<PermissionName[]> = computed(() => {
      return groupPermissions.value.map(permission => permission.name);
    });

    const formatName = (name: string) => {
      const lowerCase = name.replace(/_/g, ' ').toLowerCase();
      return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1);
    };

    const formatDependencies = (permissions: PermissionName[]) => {
      let list = '';
      permissions.forEach((perm, idx) => {
        list += formatName(perm);
        if (idx < permissions.length - 1) {
          list += ', ';
        }
      });
      return list;
    };

    const updatePermission = async (
      permission: PermissionItem,
      isAllowed: boolean
    ) => {
      try {
        if (isAllowed) {
          const payload: UpdatePermissionPayload = {
            permission,
          };
          await server.addGroupPermission(groupId, payload);
        } else {
          await server.removePermission(groupId, permission.name);
        }
        groupPermissions.value = await server.getGroupPermissions(
          Number(groupId)
        );
      } catch (err) {
        actions.showErrorSnackbar(
          'Error updating permission. Please try again.',
          err as Error
        );
      }
    };

    onMounted(async () => {
      try {
        loading.value = true;

        groupPermissions.value = await server.getGroupPermissions(
          Number(groupId)
        );
        allPermissionsOptions.value = await server.getAllPermissions();
      } catch (err) {
        actions.showErrorSnackbar(
          'Error loading group permissions. Please try again.',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    });

    return {
      loading,
      allPermissionsOptions,
      allPermissionTypes,
      groupPermissions,
      groupPermissionNames,
      formatName,
      updatePermission,
      formatDependencies,
    };
  },
});
